<div class="container-fluid">
  <div class="mct-flex mct-row mb-2">
    <h3>
      {{ 'events.settings.registration-fields.title' | translate | titlecase }}
      <a
        href="https://support.weblinkinternational.com/hc/en-us/articles/235638968-Event-Settings-Registration-Fields"
        target="_blank"
        class="ml-2"
      >
        <i
          class="pi pi-question-circle wc-help-icon"
          [title]="'events.settings.registration-fields.registration-fields-title-help' | translate"
        ></i>
      </a>
    </h3>
  </div>

  <div class="row mb-2 hidden-xs font-weight-bold">
    <div class="col-sm-offset-4 col-md-offset-3 col-sm-4 col-md-1 text-center">
      {{ 'common.visible' | translate | titlecase }}
    </div>
    <div class="col-sm-4 col-md-1 text-center">
      {{ 'common.required' | translate | titlecase }}
    </div>
  </div>

  <div class="grid-body border-top border-bottom mb-4">
    <div class="grid-row py-2 border-bottom">
      <wl-event-settings-registration-fields-field-row
        [displayName]="'common.personal-information.email-address' | translate | titlecase"
        [(visibilityFieldValue)]="event.RegEmailVisible"
        [(requiredFieldValue)]="event.RegEmailRequired"
        [registrationRequiredDisabled]="true"
        [registrationVisibleDisabled]="true"
      >
      </wl-event-settings-registration-fields-field-row>
    </div>
    <div class="grid-row py-2 border-bottom">
      <wl-event-settings-registration-fields-field-row
        [displayName]="'common.personal-information.prefix' | translate | titlecase"
        [(visibilityFieldValue)]="event.RegPrefixVisible"
        [(requiredFieldValue)]="event.RegPrefixRequired"
      >
      </wl-event-settings-registration-fields-field-row>
    </div>
    <div class="grid-row py-2 border-bottom">
      <wl-event-settings-registration-fields-field-row
        [displayName]="'common.personal-information.first-name' | translate | titlecase"
        [(visibilityFieldValue)]="event.RegFNameVisible"
        [(requiredFieldValue)]="event.RegFNameRequired"
      >
      </wl-event-settings-registration-fields-field-row>
    </div>
    <div class="grid-row py-2 border-bottom">
      <wl-event-settings-registration-fields-field-row
        [displayName]="'common.personal-information.last-name' | translate | titlecase"
        [(visibilityFieldValue)]="event.RegLNameVisible"
        [(requiredFieldValue)]="event.RegLNameRequired"
      >
      </wl-event-settings-registration-fields-field-row>
    </div>
    <div class="grid-row py-2 border-bottom">
      <wl-event-settings-registration-fields-field-row
        [displayName]="'events.settings.registration-fields.name-for-badge' | translate | titlecase"
        [(visibilityFieldValue)]="event.RegNameForBadgeVisible"
        [(requiredFieldValue)]="event.RegNameForBadgeRequired"
        [regVisibleFieldVisible]="false"
        [regRequiredVisible]="false"
      >
      </wl-event-settings-registration-fields-field-row>
    </div>
    <div class="grid-row py-2 border-bottom">
      <wl-event-settings-registration-fields-field-row
        [displayName]="'common.personal-information.company-name' | translate | titlecase"
        [(visibilityFieldValue)]="event.RegCompanyNameVisible"
        [(requiredFieldValue)]="event.RegCompanyNameRequired"
      >
      </wl-event-settings-registration-fields-field-row>
    </div>
    <div class="grid-row py-2 border-bottom">
      <wl-event-settings-registration-fields-field-row
        [displayName]="'common.personal-information.title' | translate | titlecase"
        [(visibilityFieldValue)]="event.RegTitleVisible"
        [(requiredFieldValue)]="event.RegTitleRequired"
      >
      </wl-event-settings-registration-fields-field-row>
    </div>
    <div class="grid-row py-2 border-bottom">
      <wl-event-settings-registration-fields-field-row
        [displayName]="'common.personal-information.address' | translate | titlecase"
        [(visibilityFieldValue)]="event.RegAddressVisible"
        [(requiredFieldValue)]="event.RegAddressRequired"
      >
      </wl-event-settings-registration-fields-field-row>
    </div>
    <div class="grid-row py-2">
      <wl-event-settings-registration-fields-field-row
        [displayName]="'common.personal-information.phone' | translate | titlecase"
        [(visibilityFieldValue)]="event.RegPhoneVisible"
        [(requiredFieldValue)]="event.RegPhoneRequired"
      >
      </wl-event-settings-registration-fields-field-row>
    </div>
  </div>

  <h3 class="mt-4">{{ 'events.settings.registration-fields.custom-reg-fields-title' | translate | titlecase }}</h3>

  <p>
    <button app-add-button
      [disabled]="userAccessLevel < 2"
      [label]="'events.settings.registration-fields.add-custom-field-label' | translate | titlecase"
      (onClick)="newCustomRegField()"
    >
    </button>
  </p>

  <p [hidden]="!loadingCustomRegFields.busy">
    <wl-busy [show]="loadingCustomRegFields.busy"></wl-busy>
  </p>

  <div class="alert alert-danger" *ngIf="loadingCustomRegFields.message && !loadingCustomRegFields.success">
    {{ loadingCustomRegFields.message }}
  </div>

  <table
    cdkDropList
    (cdkDropListDropped)="handleCustomFieldSortDrop($event)"
    class="table table-hover mt-3"
    *ngIf="!loadingCustomRegFields.busy && customRegFields?.length"
  >
    <thead>
      <tr>
        <th style="width: 80px">{{ 'events.settings.registration-fields.field-id-label' | translate | titlecase }}</th>
        <th>{{ 'events.settings.registration-fields.field-name-label' | translate | titlecase }}</th>
        <th>{{ 'events.settings.registration-fields.field-type-label' | translate | titlecase }}</th>
        <th class="text-right"></th>
      </tr>
    </thead>
    <tbody>
      <tr class="wc-movable" *ngFor="let customField of customRegFields" cdkDrag>
        <td class="align-middle">
          <i class="pi pi-bars mr-2 text-muted" cdkDragHandle style="cursor: move"></i>
          {{ customField.Id }}
        </td>
        <td class="align-middle font-weight-bold">{{ customField.FieldName }}</td>
        <td class="align-middle">
          <span *ngIf="!customField.UiControlType" class="badge badge-secondary">{{ 'common.none' | translate | titlecase }}</span>
          <span *ngIf="customField.UiControlType" class="text-info">
            {{ 'enum.eventcustomregfielduicontroltype.' + customField.UiControlType.toLowerCase() | translate | titlecase }}
          </span>
        </td>
        <td class="text-right align-middle">
          <div class="btn-group mct-gap-5">
            <button
              pButton
              type="button"
              class="btn btn-default btn-sm"
              (click)="editCustomRegField(customField.Id)"
              [disabled]="userAccessLevel < 2"
              icon="pi pi-pencil"
              [label]="'common.edit' | translate | titlecase"
            ></button>
            <button
              pButton
              type="button"
              class="btn btn-danger btn-sm"
              (click)="confirmDeleteCustomRegField(customField.Id)"
              [disabled]="userAccessLevel < 2"
              icon="pi pi-trash"
            ></button>
          </div>
        </td>
      </tr>
    </tbody>
  </table>

  <app-back-to-top></app-back-to-top>
</div>

<p-dialog
  #customRegFieldsEditModal
  modal="true"
  [(visible)]="showModal"
  styleClass="atlas-dialog-l"
  [focusOnShow]="false"
  [contentStyle]="{ 'max-height': '75vh' }"
>
  <ng-template pTemplate="header">
    <h4 class="modal-title">{{ 'events.settings.registration-fields.custom-reg-fields-title' | translate | titlecase }}</h4>
  </ng-template>

  <div class="container-fluid">
    <p [hidden]="!loadingCustomRegField.busy">
      <wl-busy [show]="loadingCustomRegField.busy"></wl-busy>
    </p>

    <div class="alert alert-danger" *ngIf="loadingCustomRegField.message && !loadingCustomRegField.success">
      {{ loadingCustomRegField.message }}
    </div>

    <form #customFieldEditForm="ngForm" *ngIf="!loadingCustomRegField.busy && loadingCustomRegField.success">
      <div class="form-horizontal">
        <div class="form-group">
          <label class="col-md-3 col-sm-4 control-label">{{
            'events.settings.registration-fields.field-name-label' | translate | titlecase
          }}</label>
          <div class="col-sm-8">
            <input class="form-control" type="text" name="fieldName" [(ngModel)]="eventCustomRegField.FieldName" required />
          </div>
        </div>

        <div class="form-group">
          <label class="col-md-3 col-sm-4 control-label">{{
            'events.settings.registration-fields.description-label' | translate | titlecase
          }}</label>
          <div class="col-sm-8">
            <textarea class="form-control" name="fieldDescr" [(ngModel)]="eventCustomRegField.Descr" rows="2"></textarea>
          </div>
        </div>

        <div class="form-group">
          <div class="col-sm-offset-4 col-md-offset-3 col-sm-8">
            <div class="row mb-1 hidden-xs text-muted small">
              <div class="col-xs-6 col-sm-2 text-center">{{ 'common.visible' | translate | titlecase }}</div>
              <div class="col-xs-6 col-sm-2 text-center">{{ 'common.required' | translate | titlecase }}</div>
            </div>
            <wl-event-settings-registration-fields-field-row
              offsetClass=""
              [(visibilityFieldValue)]="eventCustomRegField.Visible"
              [(requiredFieldValue)]="eventCustomRegField.Required"
            >
            </wl-event-settings-registration-fields-field-row>
            <div class="text-danger mt-1 small" *ngIf="eventCustomRegField.Visible == 0">
              <i class="pi pi-exclamation-circle mr-1"></i>
              {{ 'events.settings.registration-fields.custom-not-both-visible-error' | translate }}
            </div>
          </div>
        </div>

        <div class="form-group">
          <label class="col-md-3 col-sm-4 control-label">{{
            'events.settings.registration-fields.staff-only-label' | translate | titlecase
          }}</label>
          <div class="col-sm-8">
            <div class="checkbox mt-2">
              <p-checkbox binary="true" name="fieldStaffOnly" [(ngModel)]="eventCustomRegField.StaffOnly"></p-checkbox>
            </div>
          </div>
        </div>

        <div class="form-group">
          <label class="col-md-3 col-sm-4 control-label">{{
            'events.settings.registration-fields.applies-to-label' | translate | titlecase
          }}</label>
          <div class="col-sm-8">
            <wl-busy [show]="loadingEventItems" [isLarge]="true"></wl-busy>
            <div class="border rounded p-3 bg-light" style="max-height: 180px; overflow-y: auto">
              <div *ngFor="let eventItem of eventItems; let eventItemIndex = index" class="checkbox">
                <label>
                  <p-checkbox binary="true" [name]="'fieldApply-' + eventItemIndex" [(ngModel)]="eventItem.apply" class="mr-2"></p-checkbox>
                  {{ eventItem.eventItemName }}
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="form-group">
          <label class="col-md-3 col-sm-4 control-label">{{
            'events.settings.registration-fields.field-type-label' | translate | titlecase
          }}</label>
          <div class="col-sm-8">
            <p-dropdown
              [options]="uiControlTypes"
              name="fieldUIControlType"
              [(ngModel)]="eventCustomRegField.UiControlType"
              optionLabel="display"
              optionValue="value"
              styleClass="w-100"
              [required]="true"
              [placeholder]="'common.select' | translate"
            >
              <ng-template let-item pTemplate="item">
                {{ item.display | translate | titlecase }}
              </ng-template>
            </p-dropdown>
          </div>
        </div>

        <div class="form-group" *ngIf="eventCustomRegField.UiControlType == 'DropdownList'">
          <label class="col-md-3 col-sm-4 control-label">{{
            'events.settings.registration-fields.available-values-label' | translate | titlecase
          }}</label>
          <div class="col-sm-8">
            <div class="mb-3">
              <button app-add-button
                class="btn btn-default btn-sm"
                [label]="'events.settings.registration-fields.available-value' | translate | titlecase"
                (onClick)="addAvailableValue()"
              >
              </button>
              <span class="text-muted ml-2" *ngIf="!eventCustomRegField.AvailableValues?.length">
                {{ 'events.settings.registration-fields.available-values-placeholder' | translate }}
              </span>
            </div>

            <ul class="list-unstyled">
              <li
                class="wc-available-value-box p-3 border rounded mb-2 bg-white shadow-sm"
                [ngClass]="{ 'wc-available-value-highlight': aavailableValue._highlight }"
                *ngFor="let aavailableValue of eventCustomRegField.AvailableValues; let i = index"
              >
                <div class="pull-right btn-group mct-gap-5">
                  <button
                    pButton
                    type="button"
                    class="btn btn-xs btn-default"
                    [disabled]="!i"
                    (click)="handleAvailableValueMoveUp(i)"
                    icon="pi pi-chevron-up"
                  ></button>
                  <button
                    pButton
                    type="button"
                    class="btn btn-xs btn-default"
                    [disabled]="i == eventCustomRegField.AvailableValues.length - 1"
                    (click)="handleAvailableValueMoveDown(i)"
                    icon="pi pi-chevron-down"
                  ></button>
                  <button pButton type="button" class="btn btn-xs btn-danger" (click)="removeAvailableValue(i)" icon="pi pi-times"></button>
                </div>

                <wl-event-settings-registration-field-drop-down-values [(availableValue)]="eventCustomRegField.AvailableValues[i]">
                </wl-event-settings-registration-field-drop-down-values>

                <div class="wl-registration-field-drop-down-value-credit-type-list-container mt-2 pt-2 border-top">
                  <wl-registration-field-drop-down-value-credit-type-list [availValueCreditTypes]="aavailableValue.CreditTypes">
                  </wl-registration-field-drop-down-value-credit-type-list>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div *ngIf="eventCustomRegField.UiControlType == 'DropdownList' && totalAdditionalCost > 0">
          <div class="form-group">
            <label class="col-md-3 col-sm-4 control-label">{{
              'events.settings.registration-fields.revenue-item-label' | translate | titlecase
            }}</label>
            <div class="col-sm-8">
              <wl-revenue-item-selector name="fieldItemNum" [(ngModel)]="eventCustomRegField.ItemNum" required></wl-revenue-item-selector>
            </div>
          </div>

          <div class="form-group">
            <label class="col-md-3 col-sm-4 control-label">{{
              'events.settings.registration-fields.payment-type-label' | translate | titlecase
            }}</label>
            <div class="col-sm-8">
              <wl-payment-type-selector
                name="fieldPaymentType"
                [(ngModel)]="eventCustomRegField.PaymentTypeID"
                [(revenueItemNum)]="eventCustomRegField.ItemNum"
                [creditCardType]="true"
                required
              >
              </wl-payment-type-selector>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <ng-template pTemplate="footer">
    <div class="alert alert-danger text-left" *ngIf="customFieldSaveError">
      {{ customFieldSaveError }}
    </div>
    <div class="mct-flex mct-row mct-justify-end mct-items-center mct-gap-10">
      <wl-busy [show]="customFieldSaving"></wl-busy>
      <button
        pButton
        type="button"
        class="btn btn-primary"
        (click)="saveCustomRegFields()"
        [disabled]="customFieldSaving || eventCustomRegField.Visible == 0 || !customFieldEditForm.valid"
        icon="pi pi-save"
        [label]="(customFieldSaving ? 'common.saving' : 'common.save') | translate | titlecase"
      ></button>
      <button
        pButton
        type="button"
        class="btn btn-secondary"
        (click)="showModal = false"
        [disabled]="customFieldSaving"
        icon="pi pi-ban"
        [label]="'common.cancel' | translate | titlecase"
      ></button>
    </div>
  </ng-template>
</p-dialog>
